import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { LabelPinType } from 'src/app/story/models/labels/label-pin-type.enum';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';

@Component({
  selector: 'app-label-pin',
  templateUrl: './label-pin.component.html',
  styleUrls: ['./label-pin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelPinComponent {
  labelPinType = LabelPinType;
  labelThemeEnum = LabelThemeEnum;

  @Input()
  label: LabelModel;

  @Input()
  labelTheme: LabelThemeEnum = LabelThemeEnum.StudioNext;

  @Input()
  selected = false;

  @Input()
  sequence: number;

  constructor() {}
}
